module.exports = __webpack_public_path__ + "assets/img/item03.e38261f1.svg";